import { render, staticRenderFns } from "./driverTeamAdd.vue?vue&type=template&id=b18021fc&scoped=true"
import script from "./driverTeamAdd.vue?vue&type=script&lang=js"
export * from "./driverTeamAdd.vue?vue&type=script&lang=js"
import style0 from "./driverTeamAdd.vue?vue&type=style&index=0&id=b18021fc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b18021fc",
  null
  
)

export default component.exports